import { Injectable, inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SecurityService } from '../security/security.service';

@Injectable({ providedIn: 'root' })
class AuthGuardService {
  private router = inject(Router);
  private securityService = inject(SecurityService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = this.securityService.getToken();
    const isAuthenticated = this.securityService.isAuthenticated();
    
    console.log('🔐 AuthGuard - Verificando acceso a:', state.url);
    console.log('🔐 AuthGuard - Token existe:', !!token);
    console.log('🔐 AuthGuard - Token expirado:', this.securityService.isTokenExpired());
    console.log('🔐 AuthGuard - Autenticado:', isAuthenticated);
    
    if (token && isAuthenticated) {
      console.log('✅ AuthGuard - Acceso permitido');
      return true;
    }

    console.log('❌ AuthGuard - Acceso denegado, redirigiendo a login');
    // Limpiar datos inválidos
    this.securityService.logout();
    
    // Guardar la URL a la que intentaba acceder para redirigir después del login
    this.router.navigate(['/auth/login'], { 
      queryParams: { returnUrl: state.url } 
    });
    
    return false;
  }
}

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(AuthGuardService).canActivate(route, state);
};

